import adminRouteTree from '@/modules/administration/route-tree';
import { analyticsRoute } from '@/modules/analytics/routes';
import { assetsTransactionsRoute } from '@/modules/charge-center/assets-transactions/route';
import { chargePointsRoute } from '@/modules/charge-center/grid-connections/charge-points/route';
import { connectorsRoute } from '@/modules/charge-center/grid-connections/connectors/route';
import { gridConnectionChargePointsRoute } from '@/modules/charge-center/grid-connections/grid-connection-details/charge-points/route';
import { gridConnectionConnectorsRoute } from '@/modules/charge-center/grid-connections/grid-connection-details/connectors/route';
import { gridConnectionDetailsIndexRoute } from '@/modules/charge-center/grid-connections/grid-connection-details/index/route';
import { gridConnectionDetailsRoute } from '@/modules/charge-center/grid-connections/grid-connection-details/route';
import { gridConnectionsIndexRoute } from '@/modules/charge-center/grid-connections/index/route';
import { gridConnectionsRoute } from '@/modules/charge-center/grid-connections/route';
import { historicalUptimeRoute } from '@/modules/charge-center/historical-uptime/route';
import { chargeCenterIndexRoute } from '@/modules/charge-center/index/route';
import { chargeCenterMonitorLayoutRoute } from '@/modules/charge-center/layout/route';
import { mapRoute } from '@/modules/charge-center/map/route';
import { chargeCenterRoute } from '@/modules/charge-center/route';
import { loginRoute } from '@/modules/core/auth/login/route';
import { resetPasswordConfirmRoute } from '@/modules/core/auth/reset-password-confirm/route';
import { resetPasswordRoute } from '@/modules/core/auth/reset-password/route';
import { authenticationRoute } from '@/modules/core/auth/route';
import { notificationsRoute } from '@/modules/core/notifications/route';
import { preferencesRoute } from '@/modules/core/preferences/route';
import { connectorRedirectRoute } from '@/modules/core/root/connector-redirect/route';
import { emailValidationRoute } from '@/modules/core/root/email-validation/route';
import { indexRoute } from '@/modules/core/root/index/route';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { rootRoute } from '@/modules/core/root/route';
import { storeRedirectRoute } from '@/modules/core/root/store-redirect/route';
import { fleetIndexRoute } from '@/modules/fleet/index/route';
import { fleetMapRoute } from '@/modules/fleet/map/route';
import { fleetRoute } from '@/modules/fleet/route';
import { fleetSummaryRoute } from '@/modules/fleet/summary/route';
import { remoteManagementIndexRoute } from '@/modules/remote-management/index/route';
import { remoteManagementDetailsRoute } from '@/modules/remote-management/remote-management-details/route';
import { remoteManagementRoute } from '@/modules/remote-management/route';
import { chargesRoute } from '@/modules/sales/charges/route';
import { salesIndexRoute } from '@/modules/sales/index/route';
import { paymentsRoute } from '@/modules/sales/payments/route';
import { salesRoute } from '@/modules/sales/route';

export const routeTree = rootRoute.addChildren([
  indexRoute,
  emailValidationRoute,
  storeRedirectRoute,
  connectorRedirectRoute,
  authenticationRoute.addChildren([loginRoute, resetPasswordRoute, resetPasswordConfirmRoute]),
  protectedRoute.addChildren([
    preferencesRoute,
    notificationsRoute,
    chargeCenterRoute.addChildren([
      chargeCenterMonitorLayoutRoute.addChildren([chargeCenterIndexRoute, mapRoute]),
      assetsTransactionsRoute,
      gridConnectionsRoute.addChildren([
        gridConnectionsIndexRoute,
        chargePointsRoute,
        connectorsRoute,
        gridConnectionDetailsRoute.addChildren([
          gridConnectionDetailsIndexRoute,
          gridConnectionChargePointsRoute,
          gridConnectionConnectorsRoute,
        ]),
      ]),
      historicalUptimeRoute,
    ]),
    fleetRoute.addChildren([fleetIndexRoute, fleetMapRoute, fleetSummaryRoute]),
    remoteManagementRoute.addChildren([remoteManagementIndexRoute, remoteManagementDetailsRoute]),
    analyticsRoute,
    salesRoute.addChildren([salesIndexRoute, chargesRoute, paymentsRoute]),
    adminRouteTree,
  ]),
]);
